import { BehaviorSubject } from 'rxjs';
import { useMutation } from "@apollo/react-hooks";
import { handleResponse } from '../_helpers';
import gql from 'graphql-tag';
import axios from 'axios';

const currentUserSubject = new BehaviorSubject(localStorage.getItem('currentUser'));

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

const axiosGraphQL = axios.create({
    baseURL: process.env.REACT_APP_NODE_URL+':4000/graphql',
  });

const LOGIN = gql`
  mutation Login($email: String, $password: String) {
    login(email: $email, password: $password) {
      id
      email
    }
  }
`;

const loginQuery = (email, password) => `
  mutation {
    login(input: {email: "${email}", password: "${password}"}) {
      token
      fname
      lname
      email
      title
      phone
      bpsadminFlag
      resetPwdFlag
    }
  }
`

function login(email, password) {
    /*const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };*/
    //console.log(email,' : ',password);
    return new Promise((resolve,reject) => {
        try {
            axiosGraphQL
            .post('', {
              query: loginQuery(email, password),
            })
            .then(result => {
                //console.log(result);
                //console.log(result.data);
                if (result.data.errors) {
                  reject(result.data.errors[0].message);
                  return;
                } else {
                  //console.log(result.data.data.login.token);
                  //localStorage.setItem('currentUser', JSON.stringify(user));
                  localStorage.setItem('currentUser', result.data.data.login.token);
                  localStorage.setItem('fname', result.data.data.login.fname);
                  localStorage.setItem('lname', result.data.data.login.lname);
                  localStorage.setItem('email', result.data.data.login.email);
                  localStorage.setItem('title', result.data.data.login.title);
                  localStorage.setItem('phone', result.data.data.login.phone);
                  localStorage.setItem('bpsadminFlag', result.data.data.login.bpsadminFlag);
                  localStorage.setItem('resetPwdFlag', result.data.data.login.resetPwdFlag);
                  currentUserSubject.next(result.data.data.login.token);
                  resolve(result.data.data.login.token);
                }
                
                //return user;
            });
          } catch (err) {
            //console.log(err);
            //console.log('failed');
            reject(err);
          }
        /*return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
            .then(handleResponse)
            .then(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                currentUserSubject.next(user);
    
                return user;
            });*/
        
    })
    
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('fname');
    localStorage.removeItem('lname');
    localStorage.removeItem('email');
    localStorage.removeItem('title');
    localStorage.removeItem('phone');
    localStorage.removeItem('bpsadminFlag');
    localStorage.removeItem('resetPwdFlag');
    currentUserSubject.next(null);
}
